// extracted by mini-css-extract-plugin
export var articleContents = "BlogPost-module--articleContents--8f1d1";
export var backLink = "BlogPost-module--backLink--fc674";
export var backLinkContainer = "BlogPost-module--backLinkContainer--ba2e9";
export var bottomPattern = "BlogPost-module--bottomPattern--5f65b";
export var center = "BlogPost-module--center--422fd";
export var container = "BlogPost-module--container--6af08";
export var dark = "BlogPost-module--dark--ef1af";
export var decor = "BlogPost-module--decor--e94ba";
export var hamburger = "BlogPost-module--hamburger--0aa8d";
export var left = "BlogPost-module--left--326f2";
export var lined = "BlogPost-module--lined--76a37";
export var newsAuthorBlock = "BlogPost-module--newsAuthorBlock--bad4a";
export var newsFeatureMedia = "BlogPost-module--newsFeatureMedia--faf34";
export var newsHeader = "BlogPost-module--newsHeader--e456a";
export var quote = "BlogPost-module--quote--bd447";
export var reactCalendarMonthViewDays = "BlogPost-module--react-calendar__month-view__days--ec3d5";
export var reactCalendarTile = "BlogPost-module--react-calendar__tile--e729a";
export var reactCalendarTileActive = "BlogPost-module--react-calendar__tile--active--1d05a";
export var relativeWrapper = "BlogPost-module--relativeWrapper--dade2";
export var right = "BlogPost-module--right--aa049";
export var sidelines = "BlogPost-module--sidelines--3b5c8";
export var stop = "BlogPost-module--stop--8bbf4";
export var topLineHeader = "BlogPost-module--topLineHeader--e1722";
export var units = "BlogPost-module--units--0e041";
export var wide = "BlogPost-module--wide--cd23a";